import React from 'react';
import { Container, Image, Row, Col } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useTranslate from 'hooks/useTranslate';
import parse from 'html-react-parser';
import './styles.scss';

const UsersExpect: React.FC = () => {
	const { translate } = useTranslate();
	return (
		<section className="what-is-jobstas bg-white py-80 pb-0">
			<Container>
				<Row>
					<Col lg={6} className="my-auto">
						<div className="what-is-jobstas-content">
							<div className="main-heading">
								<h2 className="fw-bold mb-3 mb-md-4">{parse(translate('Home.whatUserExpect'))}</h2>
							</div>
							<div>
								<p>{parse(translate('Home.whatUserExpectDescription1'))}</p>
								<p>{parse(translate('Home.whatUserExpectDescription2'))}</p>
								<p>{parse(translate('Home.whatUserExpectDescription3'))}</p>
							</div>
						</div>
					</Col>
					<Col lg={6} className="my-auto">
						<div className="what-is-jobstas-img user-expect ms-auto">
							<Image
								src={IMAGE_PATHS.UsersExpectImg}
								className="w-100"
								alt="what-is-jobstas"
								loading="lazy"
							/>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default UsersExpect;
